import { Breadcrumbs, Link, MuiThemeProvider } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import op from 'simple-object-path'
import { typography } from '../../assets/styles'
import BaseTableColumn from '../../common/components/BaseTableColumn'
import DashboardCard from '../../common/components/DashboardCard'
import LoadingIndicator from '../../common/components/LoadingIndicator'
import CoolTable from '../../common/components/Table'
import currencyFilter from '../../lib/currency'
import { theme } from '../Admin/theme'

@inject(({ store: { navigate, auth, assetManager } }) => {
  return {
    navigate,
    isAuthenticated: auth.isAuthenticated,
    getAssetManagerModelConsumers: assetManager.getAssetManagerModelConsumers,
  }
})
@observer
export default class AssetManagerModel extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loadingModels: false,
    }
  }

  async componentDidMount() {
    window.document.title = 'Bob | Your models'
    await this.getModel()
  }

  async getModel() {
    this.setState({ loadingModels: true })
    const { getAssetManagerModelConsumers, isAuthenticated, modelId } = this.props
    await isAuthenticated()
    const models = await getAssetManagerModelConsumers(modelId)
    this.setState({
      model: op(models, '0/model'),
      consumers: op(models, '0/consumers'),
      loadingModels: false,
    })
  }

  onClickBack() {
    const { navigate } = this.props
    navigate(`/assetManager`)
  }

  render() {
    const { model = {}, consumers = [], loadingModels } = this.state
    const { list = consumers, onPageChange, onFilterChange, tableConfigs = [] } = this.props
    const tableConfig = tableConfigs.find(c => (c.tableId = 'asset-manager')) || { rowsPerPage: 12 }
    const listColumns = [
      {
        id: 'd4ea42b5a',
        displayName: 'Name',
        propPath: '/',
        filter: true,
        sortProp: 'owner/lastName',
        filterVal: item => `${op(item, 'owner/firstName')} ${op(item, 'owner/lastName')}`,
        displayFn: item => (
          <BaseTableColumn>{`${op(item, 'owner/firstName')} ${op(
            item,
            'owner/lastName'
          )}`}</BaseTableColumn>
        ),
      },
      {
        id: 'd4ea42b5b',
        displayName: 'Amount Managed',
        propPath: '/',
        filter: true,
        sortProp: 'type',
        filterVal: item => item.aum,
        displayFn: item => <BaseTableColumn>{currencyFilter(item.aum)}</BaseTableColumn>,
      },
      {
        id: 'd4ea42b5b',
        displayName: 'Fees',
        propPath: '/',
        filter: true,
        sortProp: 'type',
        filterVal: item => item.aum,
        displayFn: item => <BaseTableColumn>{currencyFilter(item.fee)}</BaseTableColumn>,
      },
    ]

    const tableOpts = {
      listColumns,
      list: list,
    }
    return (
      <MuiThemeProvider theme={theme}>
        {loadingModels && <LoadingIndicator loadingText="" />}
        {!loadingModels && (
          <Container fixed style={{ fontFamily: typography.baseFontFamily }}>
            <Breadcrumbs>
              <Link
                color="secondary"
                style={{ cursor: 'pointer' }}
                onClick={this.onClickBack.bind(this)}
              >
                {op(model, 'assetManager/name')}
              </Link>
              <span>{`${model.strategy} - ${model.type}`}</span>
            </Breadcrumbs>
            <br />
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="flex-end"
              style={{ verticalAlign: 'top' }}
            >
              <Grid item xs={12}>
                <span
                  style={{
                    fontSize: typography.extraLargeFontSize,
                    fontWeight: typography.mediumFontWeight,
                  }}
                ></span>
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: '10px' }}>
              <Grid item xs={3}>
                <Grid container direction="column" spacing={1}>
                  <Grid item xs={4}>
                    <DashboardCard
                      hasTitle={false}
                      title=""
                      moreTool={false}
                      style={{ height: '280px', width: '300px', textAlign: 'center' }}
                    >
                      <Grid container direction="column" style={{ display: 'table' }}>
                        <div
                          style={{ display: 'table-cell', verticalAlign: 'middle', height: 282 }}
                        >
                          <Grid item style={{ paddingBottom: 10 }}>
                            <img
                              style={{ height: 75, width: 75 }}
                              src={
                                op(model, 'assetManager/logoUrl') ||
                                'https://via.placeholder.com/75'
                              }
                              alt=""
                            />
                          </Grid>
                          <Grid item style={{ paddingBottom: 10 }}>
                            <p style={{ fontFamily: typography.baseFontFamily }}>
                              {op(model, 'assetManager/name')}
                            </p>
                          </Grid>
                          <Grid item>
                            <p style={{ fontFamily: typography.baseFontFamily }}>
                              {`${op(model, 'strategy')} - ${op(model, 'type')}`}
                            </p>
                          </Grid>
                        </div>
                      </Grid>
                    </DashboardCard>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={9}>
                <Grid container direction="row" spacing={1}>
                  <Grid item xs={4}>
                    <DashboardCard
                      hasTitle={false}
                      title=""
                      moreTool={false}
                      style={{ height: '125px', textAlign: 'center' }}
                    >
                      <Grid container direction="column" style={{ display: 'table' }}>
                        <div
                          style={{ display: 'table-cell', verticalAlign: 'middle', height: 125 }}
                        >
                          <Grid item style={{ padding: 15 }}>
                            <span>Consumers</span>
                          </Grid>
                          <Grid item>
                            <span
                              style={{
                                fontSize: typography.extraLargeFontSize,
                                fontWeight: typography.mediumFontWeight,
                              }}
                            >
                              {consumers.length}
                            </span>
                          </Grid>
                        </div>
                      </Grid>
                    </DashboardCard>
                  </Grid>
                  <Grid item xs={4}>
                    <DashboardCard
                      hasTitle={false}
                      title=""
                      moreTool={false}
                      style={{ height: '125px', textAlign: 'center' }}
                    >
                      <Grid container direction="column" style={{ display: 'table' }}>
                        <div
                          style={{ display: 'table-cell', verticalAlign: 'middle', height: 125 }}
                        >
                          <Grid item style={{ padding: 15 }}>
                            <span>Total Amount Managed</span>
                          </Grid>
                          <Grid item>
                            <span
                              style={{
                                fontSize: typography.extraLargeFontSize,
                                fontWeight: typography.mediumFontWeight,
                              }}
                            >
                              {currencyFilter(consumers.map(c => c.aum).reduce((a, b) => a + b, 0))}
                            </span>
                          </Grid>
                        </div>
                      </Grid>
                    </DashboardCard>
                  </Grid>
                  <Grid item xs={4}>
                    <DashboardCard
                      hasTitle={false}
                      title=""
                      moreTool={false}
                      style={{ height: '125px', textAlign: 'center' }}
                    >
                      <Grid container direction="column" style={{ display: 'table' }}>
                        <div
                          style={{ display: 'table-cell', verticalAlign: 'middle', height: 125 }}
                        >
                          <Grid item style={{ padding: 15 }}>
                            <span>Total Fee</span>
                          </Grid>
                          <Grid item>
                            <span
                              style={{
                                fontSize: typography.extraLargeFontSize,
                                fontWeight: typography.mediumFontWeight,
                              }}
                            >
                              {currencyFilter(consumers.map(c => c.fee).reduce((a, b) => a + b, 0))}
                            </span>
                          </Grid>
                        </div>
                      </Grid>
                    </DashboardCard>
                  </Grid>

                  <Grid item xs={12}>
                    <DashboardCard hasTitle={false} title="" moreTool={false}>
                      <Grid
                        container
                        direction="row"
                        justify="space-between"
                        alignItems="flex-start"
                        style={{ padding: 15 }}
                      >
                        <Grid item xs={3}>
                          <span>Model Consumers</span>
                        </Grid>
                        <Grid item xs={9} style={{ width: '100%' }}>
                          <Grid
                            container
                            direction="row"
                            justify="flex-end"
                            alignItems="flex-start"
                            spacing={2}
                          ></Grid>
                        </Grid>
                      </Grid>

                      <Box>
                        {!!tableOpts.list.length && (
                          <CoolTable
                            {...tableOpts}
                            tableConfig={tableConfig}
                            tableId="asset-manager"
                            onFilterChange={onFilterChange}
                            onPageChange={onPageChange}
                          />
                        )}
                        {!tableOpts.list.length && (
                          <Grid container direction="row" justify="center" spacing={2}>
                            <span
                              style={{
                                fontSize: typography.mediumFontSize,
                                fontWeight: typography.mediumFontWeight,
                              }}
                            >{`You have no models!`}</span>
                          </Grid>
                        )}
                      </Box>
                    </DashboardCard>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Container>
        )}
      </MuiThemeProvider>
    )
  }
}
